import axios from "axios"
import { useEffect } from "react"
import ListingsPage from "../components/listing/listing-page"
import { fetchDeletedListings, fetchListings } from "../services/NetworkRequests"
import { generateAlgoliaQueryFromFilters } from "../utils/filter-utlils"
import {
  checkUA,
  getBreadcrumbs,
  getPaginationUrl,
  getSEOLinks,
  getType,
  parseCookies,
  recordPageView,
} from "../utils/utility"


const algoliaKeyMapping = {
  flt_area_max: "area_max",
  flt_area_min: "area_min",
  flt_price_max: "price_max",
  flt_price_min: "price_min",
  flt_beds: "beds_in",
  flt_keywords: "keywords",
}

const Listings = (props) => {
  const { error } = props

  return error ? (
    <Error statusCode={404} />
  ) : (
    <>
      <ListingsPage {...props} />
    </>
  )
}

export default Listings

export async function getServerSideProps(ctx) {
  const { query, resolvedUrl, req } = ctx
  const { searchSlug, sort } = query
  let searchPath = `/${searchSlug.join("/")}`
  const resp = await axios
    .get(`${process.env.BASE_URL_CONTENT}/get-search-page`, {
      params: {
        urlPath: searchPath,
      },
    })
    .then((resp) => resp)
    .catch((error) => error)

  let isMobile = checkUA(ctx.req.headers["user-agent"])
  let props = {}

  if (resp && resp.status == 200) {
    const { data } = resp
    const { slug, new_search_page, page, should_redirect } = data
    if (should_redirect) {
      ctx.res.writeHead(301, {
        Location: `${slug}/${page > 1 ? `?page=${page}` : ""}${!!sort ? `sort=${sort}` : ""}`,
      })
      ctx.res.end()
    } else {
      const { new_search_page } = data
      const {
        hierarchy: resHierarchy,
        type,
        purpose_id,
        location_id,
        loc_level,
        flt_keywords: keywords,
      } = new_search_page
      let initialFilters = {}

      initialFilters["purpose_id"] = purpose_id
      initialFilters["location_id"] = location_id
      initialFilters["type"] = getType(type.external_id)
      initialFilters["city_id"] = resHierarchy[2].externalID
      initialFilters["province_id"] = resHierarchy[2].externalID
      initialFilters["level"] = loc_level
      Object.keys(new_search_page).map((key) =>
        algoliaKeyMapping[key] ? (initialFilters[algoliaKeyMapping[key]] = new_search_page[key]) : null
      )

      props = { ...new_search_page, hierarchy: resHierarchy.map((h) => h.externalID), initialFilters }

      const { hierarchy, h1, meta_title, meta_description, seo_content } = props
      let area = JSON.parse(parseCookies(req).area_unit || '{ "short": "Marla", "value": "Marla" }')
      let algoliaQueryObj = generateAlgoliaQueryFromFilters(query, initialFilters)
      let queryString = keywords ? keywords.split(",").join(" ") : ""

      let res = await fetchListings(sort, algoliaQueryObj)
      let deleted = []
      if (res.nbHits < 5) {
        let deletedResp = await fetchDeletedListings(algoliaQueryObj, queryString)
        deleted = deletedResp?.hits.slice(0, 25 - res.nbHits) || []
      }
      // TODO: Promise.all
      let links = await getSEOLinks({
        location_id: initialFilters.location_id,
        purpose_id: initialFilters.purpose_id,
        type_id: initialFilters.type.id,
        type_parent_id: initialFilters.type.parentId,
        province_id: initialFilters.province_id,
        level: props.loc_level,
      })
      let breadcrumbs = await getBreadcrumbs(hierarchy.slice(2), initialFilters.purpose_id, initialFilters.type.id)
      const { nextPageLink, prevPageLink } = getPaginationUrl(query, resolvedUrl, res.nbPages)

      breadcrumbs = breadcrumbs.slice(0, -1).map((item) => ({ slug: item.slug, title: item.locality_name }))

      return {
        props: {
          deletedHits: deleted,
          hits: res.hits,
          nbHits: res.nbHits,
          page: res.page,
          nbPages: res.nbPages,
          hitsPerPage: res.hitsPerPage,
          initialFilters: { ...initialFilters, area, resHierarchy },
          breadcrumbs: breadcrumbs,
          location: null,
          resolvedUrl,
          h1,
          meta_title,
          meta_description,
          seo_content,
          links,
          isMobile,
          nextPageLink,
          sort: sort || null,
          prevPageLink,
        },
      }
    }
  } else {
    return {
      props: {
        error: true,
      },
      notFound: true,
    }
  }
}
